
import { Link } from "react-router-dom";

import "./FeaturedArticle.css";

export default function FeaturedArticle({ article }) {
    if (!article) {
        return null;
    }

    return (
        <article className="featured-article">

            <Link
                to={`/articles/${article.slug}`}
                className="featured-article__image"
            >
                <img
                    src={article.image}
                    alt={article.title}
                />
            </Link>

            <div className="featured-article__content">

                <span className="featured-article__category">
                    {article.category.title}
                </span>

                <h2>
                    <Link to={`/articles/${article.slug}`}>
                        {article.title}
                    </Link>
                </h2>

                <p>
                    {article.excerpt}
                </p>

                <div className="featured-article__meta">

                    <span>
                        👁 {article.visited.toLocaleString("fa-IR")}
                    </span>

                    <span>
                        {article.publishedAt}
                    </span>

                </div>

                <Link
                    to={`/articles/${article.slug}`}
                    className="featured-article__button"
                >
                    مطالعه مقاله
                    <span>←</span>
                </Link>

            </div>

        </article>
    );
}